var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{ref:"formItem",staticClass:"sky-url-link"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.openUrl}},[_vm._v("\n    云桌面版本更新功能速查表\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }